import * as actionTypes from './types';

function setPlaceGuideContent(state, action) {
    return {
        ...state,
        [action.meta]: action.payload,
    };
}

const reducerFunctions = {
    [actionTypes.SET_PLACE_GUIDE_CONTENT]: setPlaceGuideContent,
};

export default function reducer(state = {}, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
